// Área "Discadora" — integração CRM → discadora (03/11/2026; contas desde 04/11, resposta do Eduardo).
// 151 = Goodata (cliente 20, chave de integração). 9175 = BotConversa: desde 05/11 TAMBÉM no cliente 20
// com a mesma chave (antes: painel, cliente 19).
//
// 05/11/2026: QUEM TEM a discadora vem da tabela funcionalidade_conta do CRM (liga/desliga no banco),
// não mais de listas fixas aqui:
//   "discadora"        área + mailing automático; opcoes.usuarios = [ids] restringe a área a esses usuários
//   "discadora_ligar"  botão Ligar (chat e card do Kanban); só aparece para quem tem atendente da discadora
// O serviço discadora-crm (/api/discadora/*) também confere a tabela e ainda exige a conta no DISC_CONTAS
// com a chave (a chave é segredo e fica no servidor).
import { Funcionalidades, funcionalidadeAtiva, lerFuncionalidades } from "../funcionalidades";

export const FUNC_DISCADORA = "discadora";
export const FUNC_DISCADORA_LIGAR = "discadora_ligar";

export const podeVerDiscadora = (f: Funcionalidades | null): boolean => {
  if (!f) return false;
  const area = f[FUNC_DISCADORA];
  if (!area && !f[FUNC_DISCADORA_LIGAR]) return false;
  const usuarios = area?.usuarios;
  if (!Array.isArray(usuarios)) return true;
  return usuarios.map(String).includes(localStorage.getItem("id_user") || "");
};

export const canViewDiscadora = (): boolean => podeVerDiscadora(lerFuncionalidades());

export const ligarNaConta = (f: Funcionalidades | null = lerFuncionalidades()): boolean =>
  funcionalidadeAtiva(FUNC_DISCADORA_LIGAR, f);
